(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-v1"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.lux-product-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,

    arrows: true,              
    dots: false,

    autoplay: true,
    autoplaySpeed: 2000,       

    pauseOnHover: true,        
    pauseOnFocus: true,       

    infinite: true,
    speed: 2000,

    prevArrow: '<button class="slick-prev">←</button>',  // optional custom
    nextArrow: '<button class="slick-next">→</button>',

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});

  } catch(e) { console.error(e); }
})();
})();
